const apiConfig = {
  baseUrl: 'https://api.themoviedb.org/3/',
  apiKey: 'e2b70442f11d22b479172b246c54401e',
  originalImage: (imgPath) => `https://image.tmdb.org/t/p/original/${imgPath}`,
  w500Image: (imgPath) => `https://image.tmdb.org/t/p/w500/${imgPath}`,
};

export default apiConfig;
